import { Component, OnInit } from '@angular/core';
import { Denunciante } from 'src/app/models/Denunciante';
import { ConvertirFlag, getBooleanFlag, NumIdTipDenAnonimo, isEmpty, openModalMensaje, StrDscToolTipText, recupToolTipCar } from 'src/app/general/variables';
import { MatDialog } from '@angular/material';
import { CatalogoService } from 'src/app/services/Catalogo.service';
import { Catalogo } from 'src/app/models/Catalogo';

@Component({
  selector: 'app-encuesta',
  templateUrl: './encuesta.component.html',
  styleUrls: ['./encuesta.component.css']
})
export class EncuestaComponent implements OnInit {

  strDscTooltip: string = StrDscToolTipText;

  flgLectura = false;
  flgEsServidorPublico = false;
  flgEsTestigoHecho = false;
  flgAccesoInformacion = false;
  strDscEnteroHecho = '';
  strDscTitulo = 'Información General';
  listRangoEdad: Catalogo[] = [];
  strCodSexo: string = null;
  numIdRangoEdad: number = null;
  cfurRangoEdad: any = {};

  constructor(public dialog: MatDialog,
              protected catalogoService: CatalogoService
    ) { }

  ngOnInit() {

    this.catalogoService.listarCatalogo(3).subscribe(
      data => {
        this.listRangoEdad = data;
      });

  }

  _cambioEnteroHecho() {

    this.strDscTooltip = recupToolTipCar(this.strDscEnteroHecho);


  }
  _cambioRangoEdad(numIdRangoEdad){
    this.listRangoEdad.forEach(cat => {
      if (cat.ncatalogoId === numIdRangoEdad) {
        this.cfurRangoEdad = cat;
      }
    });
  }
  setEncuestaDenunciante(data: Denunciante) {


    if (data != null) {

      this.flgEsServidorPublico =  getBooleanFlag(data.cdenuncianteFlgservpub);
      this.flgEsTestigoHecho = getBooleanFlag(data.cdenuncianteFlgtestigoh);
      this.flgAccesoInformacion = getBooleanFlag(data.cdenuncianteFlgaccdirinf);
      this.strDscEnteroHecho = data.cdenuncianteDscenterohecho;

      this.numIdRangoEdad = data.ndenuncianteIdrangoedad;
      this.strCodSexo = data.cdenuncianteCodsexo;
      this.cfurRangoEdad = data.cfurRangoEdad;
    }

  }

  getEncuestaDenunciante() {

    const data: Denunciante = new Denunciante();

    data.cdenuncianteFlgservpub = ConvertirFlag(this.flgEsServidorPublico);
    data.cdenuncianteFlgtestigoh = ConvertirFlag(this.flgEsTestigoHecho);
    data.cdenuncianteFlgaccdirinf = ConvertirFlag(this.flgAccesoInformacion);
    data.cdenuncianteDscenterohecho = this.strDscEnteroHecho;
    data.cdenuncianteFlganonimo = 'SI';
    data.ndenuncianteIdtipden = NumIdTipDenAnonimo;
    data.ndenuncianteIdrangoedad = this.numIdRangoEdad;
    data.cdenuncianteCodsexo = this.strCodSexo;
    data.cfurRangoEdad = this.cfurRangoEdad;
    return data;

  }

  validarDatosEncuesta() {

    let vFlgError = false;

    if (isEmpty(this.strDscEnteroHecho)) {

      openModalMensaje(this.strDscTitulo, 'Debe completar el campo ¿Cómo se enteró del hecho irregular?; Por favor verifique.', this.dialog);

      vFlgError = true;

    }

    if (isEmpty(this.strCodSexo)) {

      openModalMensaje(this.strDscTitulo, 'Debe ingresar el sexo, por favor verifique', this.dialog);

      vFlgError = true;

    }

    if (this.numIdRangoEdad == null) {

      openModalMensaje(this.strDscTitulo, 'Debe ingresar la edad, por favor verifique', this.dialog);

      vFlgError = true;

    }

    return vFlgError;

  }

  _cambioServidor(flgEvent) {

    // var vFlgChecked = flgEvent.checked;

    this.flgEsServidorPublico = flgEvent;

  }

  _cambioTestigo(flgEvent) {

    // var vFlgChecked = flgEvent.checked;

    this.flgEsTestigoHecho = flgEvent;


  }

  _cambioAccesoInfo(flgEvent) {

    this.flgAccesoInformacion = flgEvent;

  }



  setModoLectura(data: boolean) {

    this.flgLectura = data;

  }

  _asignarSexo(evento) {

    // this.flgSexo = flgEvent.checked;
    this.strCodSexo = evento.target.value;

  }

}
